<div class="row mt-4">
    <div class="col-sm-12">
        <i class="fa fa-facebook-square mr-3" aria-hidden="true"></i>
        <i class="fa fa-instagram mr-3" aria-hidden="true"></i>
        <i class="fa fa-youtube-play" aria-hidden="true"></i>
    </div>
</div>